import React from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';
import ProgressRing from '@adsk/alloy-react-progress-ring';

const EntityPickerModalLoadMoreLoader = () => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <Flex alignItems="center" height="68px" paddingLeft="50px">
      <ProgressRing
        size={ProgressRing.SIZES.SMALL}
        style={{ margin: '5px 0' }}
      />
      <Text typography="bodySmall" color="charcoal700" marginLeft="13px">
        {T.translate('LOADING_MORE_RESULTS')}
      </Text>
    </Flex>
  );
};

export default EntityPickerModalLoadMoreLoader;
